<main id="content">
  <section data-view-type="fullscreen" id="exercise">
    <div [ngStyle]="{'background': '#464646 url(' + exerciseDetailsObj.image + ')'}" class="hero hero-exercise"></div>
    <section id="exercise-info">
      <div class="container flex-column middle">
        <div class="row flex-row middle">
          <div class="col-md-10 desktop-show">
            <ul class="breadcrumbs inline-block">
              <li>{{exerciseDetailsObj.path_name}}</li>
            </ul>
            <div class="group">
              <h1 class="heading-lg">{{exerciseDetailsObj.sequence}}. {{exerciseDetailsObj.name}}</h1>
            </div>
          </div>
          <div class="col-md-2 text-right">
            <a role="button" data-toggle="modal" data-target="#cancelExerciseModal" (click)="exerciseModal()" class="btn cancelExerButton">cancel exercise</a>
          </div>
        </div>
      </div>
    </section>
    <!-- <section *ngIf="!showProgressBar">
      <div class="text-center exercise-start">
        <h1 class="heading-sm">Exercise will start in </h1>
        <div class="heading-lg-div">{{exerciseStartSeconds}}</div>
      </div>
    </section> -->
    <section *ngIf="!showProgressBar">
      <div class="text-center exercise-start">
        <h1 class="heading-sm">Press play below to start exercise</h1>
      </div>
    </section>
    <div class="player">
      <div class="col-md-10 exercise-details mobile-show">
        <ul class="breadcrumbs inline-block">
          <li>{{exerciseDetailsObj.path_name}}</li>
        </ul>
        <div class="group">
          <h1 class="heading-lg">{{exerciseDetailsObj.sequence}}. {{exerciseDetailsObj.name}}</h1>
        </div>
      </div>
      <div class="container exercise-player">
        <div class="row player-container">
          <div class="group player-time-indicator text-center mobile-show text-center">
            <span class="current-time">{{audioCurrentTime}}</span>
            <span class="duration">{{audioDuration}}</span>
          </div>
          <div class="player-bar flex-row middle">
            <div href="#" role="button" [attr.data-action]="audioStatus" class="btn player-btn">
              <i class="fa fa-play D3" *ngIf="audioStatus == 'play'" (click)="onAudioPlay()"></i>
              <i class="fa fa-pause D3" *ngIf="audioStatus == 'pause'" (click)="onAudioPause()"></i>
              <audio id="exerciseAudio" #audioOption src={{exerciseDetailsObj.audio}} type="audio/mp3">
              </audio>
            </div>
            <span data-action="setCurrentTime" class="player-progress-bar">
              <span class="progress" [style.width]="audioWidth"></span>
            </span>
            <div class="group player-time-indicator desktop-show">
              <span class="current-time">{{audioCurrentTime}}</span>
              <span class="duration">{{audioDuration}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<div id="cancelExerciseModal" class="modal">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h1 class="heading-lg">Cancel Exercise</h1>
              <p class="text text-md">You’re about to cancel the exercise and all the progress so far will be lost</p>
              <button (click)="goToExercise()" class="btn btn-lg btn-danger">YES, cancel exercise</button>
              <button data-dismiss="modal" (click)="cancelAction()" #dismissModal class="btn btn-link">Continue Exercise</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="feedbackModal" class="modal" [ngClass]="{'completeExerciseModal': !showFeedbackContent}">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <div class="row" *ngIf="showFeedbackContent">
          <div class="col-md-12">
            <h1 class="heading-lg">What did you think about this exercise ?</h1>
            <p class="text text-md">Your opinion is very important for us, so we will really appreciate it if you could rate your satisfaction.</p>
            <div class="feedback-container desktop-show">
              <div class="wrap">
                <div (click)="rating(1)">
                  <img src="{{smiley1}}">
                  <h4>DISLIKE</h4>
                </div>
                <div (click)="rating(2)">
                  <img src="{{smiley2}}">
                  <h4>OK</h4>
                </div>
                <div (click)="rating(3)">
                  <img src="{{smiley3}}">
                  <h4>LIKE</h4>
                </div>
                <div (click)="rating(4)">
                  <img src="{{smiley4}}">
                  <h4>LOVE IT</h4>
                </div>
              </div>
              <button (click)="feedbackNotNow('no')" class="btn btn-link" *ngIf="!showFeedback">Not Now</button>
              <div class="comment" *ngIf="showFeedback">
                <input name="feedback-comment" (ngModelChange)="onChangeFeedbackInput($event)" [(ngModel)]="feedbackBtnText" placeholder="Click here to write some details (optional)" class="input input-lg">
                <button (click)="feedbackNotNow()" class="btn btn-lg btn-primary">Send Feedback</button>
              </div>
            </div>
            <div class="feedback-container mobile-show">
              <div class="wrap wrap-div">
                <div (click)="rating(1)">
                  <img src="{{smiley1}}">
                  <h4>DISLIKE</h4>
                </div>
                <div (click)="rating(2)">
                  <img src="{{smiley2}}">
                  <h4>OK</h4>
                </div>
              </div>
              <div class="wrap wrap-div">
                <div (click)="rating(3)">
                  <img src="{{smiley3}}">
                  <h4>LIKE</h4>
                </div>
                <div (click)="rating(4)">
                  <img src="{{smiley4}}">
                  <h4>LOVE IT</h4>
                </div>
              </div>
              <button (click)="feedbackNotNow('no')" class="btn btn-link" *ngIf="!showFeedback">Not Now</button>
              <div class="comment" *ngIf="showFeedback">
                <input name="feedback-comment" (ngModelChange)="onChangeFeedbackInput($event)" [(ngModel)]="feedbackBtnText" placeholder="Click here to write some details (optional)" class="input input-lg">
                <button (click)="feedbackNotNow()" class="btn btn-lg btn-primary">Send Feedback</button>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid" *ngIf="!showFeedbackContent">
            <div class="row body">
              <div class="col-md-2 text-right monk-div">
                <img src="/assets/images/monk.png" alt="doctor img" class="image">
              </div>
              <div class="col-md-8 description">
                <h1 class="heading-lg">Good Job !</h1>
                <p class="text text-xl">Pain can be difficult to manage. Our meditation program will make it more manageable for you.&nbsp;
                  <span (click)="navigateAction('/single-meditation')">Do you want to do a meditation ?</span>
                </p>
                <div data-view="socialPanel"></div>
              </div>
            </div>
            <div class="row footer">
              <div class="col-md-8 col-md-offset-2">
                <button (click)="navigateAction('/exercise/current')" class="btn btn-block btn-lg btn-primary">Go to your next exercise</button>
                <button (click)="navigateAction('paths')" class="btn btn-block btn-lg">Maybe later</button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/ongoing/ongoing.component.html